export const aboutData = {
  brandName: '悟空影视',
  brandSlogan: '海量高清 即点即播 完全免费',
  foundedYear: '2018',
  introduction: `悟空影视成立于2018年，是国内领先的免费在线影视平台。自创立以来，我们始终秉持"让每个人都能轻松享受优质影视内容"的初心，致力于为广大影迷提供最便捷、最流畅的在线观影体验。

悟空影视平台汇聚了来自全球的海量影视资源，涵盖电影、电视剧、动漫、综艺、纪录片等多种类型，满足不同年龄段、不同口味用户的观影需求。无论是最新上映的院线大片，还是经典怀旧的老电影，又或者是正在热播的电视剧，在悟空影视都能找到。

我们的技术团队不断优化播放体验，采用先进的视频编解码技术和全球CDN加速节点，确保每一位用户都能享受到流畅不缓冲的高清观影体验。

悟空影视始终坚持免费服务的原则，无需注册登录即可观看所有内容，真正做到了"零门槛、零成本"的观影体验。`,
  features: [
    { icon: 'ri-movie-2-line', title: '海量资源', description: '收录超过10万部影视作品，涵盖电影、电视剧、动漫、综艺、纪录片等全品类内容，每日更新最新资源。' },
    { icon: 'ri-4k-line', title: '高清画质', description: '支持1080P、4K超清画质播放，采用H.265编码技术，在保证画质的同时最大限度节省流量。' },
    { icon: 'ri-speed-up-line', title: '流畅不卡', description: '全球CDN加速节点覆盖，智能匹配最优线路，即使在网络不佳的环境下也能流畅播放。' },
    { icon: 'ri-user-star-line', title: '无需注册', description: '无需注册账号，无需登录，打开即看。我们相信好的服务不应该设置门槛。' },
    { icon: 'ri-shield-check-line', title: '安全无广告', description: '严格的内容审核机制，无弹窗广告、无恶意软件，为用户提供干净安全的观影环境。' },
    { icon: 'ri-smartphone-line', title: '多端适配', description: '完美适配电脑、平板、手机等各类设备，随时随地享受观影乐趣。' },
  ],
  testimonials: [
    {
      name: '张先生',
      location: '北京',
      content: '用了悟空影视三年了，资源真的很全。想看的新片基本都能找到，而且画质清晰、播放流畅，必须给好评！',
      rating: 5,
    },
    {
      name: '李女士',
      location: '上海',
      content: '追剧神器！更新速度很快，晚上追的剧第二天就能看到更新。不需要注册这点真的很方便，推荐给身边所有喜欢追剧的朋友了。',
      rating: 5,
    },
    {
      name: '王同学',
      location: '广州',
      content: '学生党福音！免费不说，资源还这么多。周末宅在家里刷电影，一整天都不带重样的，真的太香了。',
      rating: 5,
    },
    {
      name: '赵女士',
      location: '成都',
      content: '给家里老人用的，操作简单，打开就能看。老人家喜欢看老电影和戏曲，在这里都能找到，非常满意。',
      rating: 4,
    },
    {
      name: '刘先生',
      location: '深圳',
      content: '动漫资源特别全，连一些比较冷门的番都能找到。播放器体验也很好，支持倍速播放和记忆播放进度，用起来很顺手。',
      rating: 5,
    },
    {
      name: '陈女士',
      location: '杭州',
      content: '从朋友那里知道悟空影视的，一用就离不开了。综艺更新得特别及时，周末就可以看一周的综艺合集，太方便了。',
      rating: 5,
    },
  ],
  stats: [
    { label: '影视资源', value: '100,000+' },
    { label: '日活用户', value: '500万+' },
    { label: '累计播放', value: '100亿+' },
    { label: '用户好评率', value: '98.5%' },
  ],
  contactInfo: {
    email: 'service@wukongyingshi.com',
    phone: '400-888-0000',
    wechat: '悟空影视官方号',
    weibo: '@悟空影视',
    address: '北京市朝阳区光华路8号',
    workHours: '周一至周日 9:00 - 22:00',
  },
  faqs: [
    {
      question: '悟空影视是免费的吗？',
      answer: '是的，悟空影视完全免费。我们始终坚持免费服务的原则，所有影视内容都无需付费即可观看。无需注册账号，无需登录，打开网站即可开始观影。',
    },
    {
      question: '需要下载APP才能观看吗？',
      answer: '不需要。悟空影视是纯网页版平台，通过浏览器即可直接观看。无论您使用的是电脑、平板还是手机，打开浏览器输入网址就能看，无需下载安装任何软件。',
    },
    {
      question: '支持哪些清晰度？',
      answer: '悟空影视支持多种清晰度选择，包括标清（480P）、高清（720P）、全高清（1080P）和超清（4K）。系统会根据您的网络状况自动推荐最合适的清晰度，您也可以手动切换。',
    },
    {
      question: '播放卡顿怎么办？',
      answer: '如果您遇到播放卡顿的情况，可以尝试以下方法：1）切换至较低清晰度；2）暂停缓冲一会儿再播放；3）检查网络连接是否稳定；4）刷新页面重试。我们的CDN加速网络会自动为您选择最优线路。',
    },
    {
      question: '如何搜索想看的影片？',
      answer: '在网站首页顶部的搜索框中输入影片名称、导演或演员名字，即可快速找到您想看的内容。您也可以通过分类导航浏览不同类型的影视作品。',
    },
    {
      question: '会在悟空影视上看到广告吗？',
      answer: '悟空影视致力于提供纯净的观影体验。我们不会在播放过程中插入任何形式的视频广告或弹窗广告，让您的观影过程不受打扰。',
    },
  ],
};